import { Navigate, Route, Routes } from "react-router-dom";
import { ContactDetailPage } from "./ContactDetailPage";
import { ContactEditorPage } from "./ContactEditorPage";
import { ContactsPage } from "./ContactsPage";

export function ContactsRoutes() {
  return (
    <Routes>
      <Route index element={<ContactsPage />} />
      <Route path="new" element={<ContactEditorPage />} />
      <Route path=":contactId" element={<ContactDetailPage />} />
      <Route path=":contactId/edit" element={<ContactEditorPage />} />
      <Route path="*" element={<Navigate to="/contacts" replace />} />
    </Routes>
  );
}
